<template>

    <b-modal
        id="approve-game-modal"
        title="Zatwierdź grę"
        ok-only
        ok-title="Zamknij"
        ok-variant="secondary"
        no-close-on-backdrop
        size="md"
        @hidden="approveGameModalHandleHide">

        <div>

            <div class="mb-2">
                <strong>Gra: {{ game.display_name }} ({{ game.output_identification_name }})</strong>
            </div>

            <div class="mb-5">
                <span class="badge badge-primary mr-1">{{ getRepoDisplayName(game.repo) }}</span> <i class="fa fa-arrow-right"></i> <span class="badge badge-primary ml-1">{{ getRepoDisplayName(repo) }}</span>
            </div>

            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th width="50%">
                            <strong>Zatwierdź całą grę</strong>
                        </th>
                        <th width="50%">
                            <strong>Zatwierdź tylko tłumaczenia</strong>
                        </th>
                    </tr>
                </thead>
                <tbody>
                <tr>
                    <td style="vertical-align: top;">
                        <p class="mb-0">Przejdź do widoku zatwierdzenia całej gry - konfiguracji, tłumaczeń oraz źródeł.</p>
                    </td>
                    <td style="vertical-align: top;">
                        <p>Przejdź do widoku zatwierdzania wyłącznie tłumaczeń gry (bez konfiguracji oraz źródeł).</p>
                        <p class="mb-0">Aby możliwe było zatwierdzenie samych tłumaczeń gry, w repozytorium docelowym musi istnieć odpowiednik gry. Ponadto wszystkie klucze tłumaczeń z bazowego pliku tłumaczeń gry, muszą istnieć w odpowiadającym pliku w repozytorium docelowym.</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <b-button variant="success" size="sm" @click="initApproveCompleteGame">Przejdź</b-button>
                    </td>
                    <td>
                        <b-button variant="success" size="sm" @click="initApproveOnlyGameTranslations">Przejdź</b-button>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>

    </b-modal>

</template>

<script>

    export default {

        name: 'GameLibraryApproveGameModal',

        data() {
            return {
                eventHub: window.eventHub,
                game: {
                    display_name: null,
                    output_identification_name: null,
                    repo: null
                },
                repo: null
            }
        },

        mounted() {

            this.eventHub.$on('game-library-show-approve-game-modal' , (game) => {
                this.game = game;
                if (game.repo === 'dev') {
                    this.repo = 'test';
                } else if (game.repo === 'test') {
                    this.repo = 'prod';
                } else {
                    alert('Niepoprawne repozytorium gry: ' + game.repo)
                }
                this.$bvModal.show('approve-game-modal');
            });

        },

        methods: {

            getRepoDisplayName(repo) {
                if (repo === 'dev') {
                    return 'Deweloperskie';
                } else if (repo === 'test') {
                    return 'Testowe';
                } else if (repo === 'prod') {
                    return 'Produkcyjne';
                }
                return 'Nieznane';
            },

            approveGameModalHandleHide() {

            },

            initApproveCompleteGame() {
                this.$bvModal.hide('approve-game-modal');
                this.eventHub.$emit('game-library-approve-element', 'game', {
                    id: this.game.id,
                    display_name: this.game.display_name,
                    updated_at: this.game.updated_at ? (new Date(this.game.updated_at)).toLocaleString() : '---',
                    approved_at: this.game.approved_at ? (new Date(this.game.approved_at)).toLocaleString() : '---',
                    files_updated_at: this.game.files_updated_at ? (new Date(this.game.files_updated_at)).toLocaleString() : '---',
                    translations_updated_at: this.game.translations_updated_at !== null ? (new Date(this.game.translations_updated_at)).toLocaleString() : '---',
                    files_were_updated_since_last_approve: this.game.files_were_updated_since_last_approve,
                    config_was_updated_since_last_approve: this.game.config_was_updated_since_last_approve,
                    translations_were_updated_since_last_approve: this.game.translations_were_updated_since_last_approve,
                });
            },

            initApproveOnlyGameTranslations() {

                this.eventHub.$emit('game-library-show-approve-game-translations-modal', this.game);

            }

        }

    }

</script>

<style>



</style>
